import { handleTablistKeydown, setTablistRovingState } from '@theme/coco-utilities';

if (!customElements.get('mega-menu-collections')) {
  class MegaMenuCollections extends HTMLElement {
    constructor() {
      super();
      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleTabKeydown = this.handleTabKeydown.bind(this);
    }

    connectedCallback() {
      this.tabs = this.querySelectorAll('[data-collection-tab]');
      this.panels = this.querySelectorAll('[data-collection-panel]');
      if (!this.tabs.length || !this.panels.length) return;

      this.tabsArray = Array.from(this.tabs);

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.handleTabClick);
        tab.addEventListener('keydown', this.handleTabKeydown);
      });

      const activeIndex = this.getActiveIndex();
      if (activeIndex != null) this.showPanel(activeIndex);
    }

    disconnectedCallback() {
      this.tabs?.forEach((tab) => {
        tab.removeEventListener('click', this.handleTabClick);
        tab.removeEventListener('keydown', this.handleTabKeydown);
      });
    }

    getActiveIndex() {
      const active = this.tabsArray.find((tab) => tab.classList.contains('active'));
      return active?.dataset.index ?? this.tabsArray[0]?.dataset.index ?? null;
    }

    showPanel(index) {
      if (index == null) return;

      const indexValue = String(index);

      setTablistRovingState(this.tabsArray, (tab) => tab.dataset.index === indexValue, {
        activeClass: 'active',
      });

      this.tabsArray.forEach((tab) => {
        const indicator = tab.querySelector('[data-tab-indicator]');
        if (indicator) indicator.hidden = tab.dataset.index !== indexValue;
      });

      this.panels.forEach((panel) => {
        const isActive = panel.dataset.index === indexValue;
        panel.classList.toggle('active', isActive);

        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    handleTabClick(event) {
      event.preventDefault();
      const index = event.currentTarget.dataset.index;
      if (index == null) return;
      this.showPanel(index);
    }

    handleTabKeydown(event) {
      handleTablistKeydown(
        event,
        this.tabsArray,
        (tab) => {
          const idx = tab?.dataset?.index;
          if (idx != null) this.showPanel(idx);
        },
        { orientation: 'vertical' },
      );
    }
  }

  customElements.define('mega-menu-collections', MegaMenuCollections);
}
